export default __webpack_public_path__ + "static/media/refer-a-friend.9021ba7e.png";